module.exports = __webpack_public_path__ + "img/pin_blue_camion.647f2ca5.svg";